import { render, staticRenderFns } from "./index-wuye.vue?vue&type=template&id=5794679e&scoped=true&"
import script from "./index-wuye.vue?vue&type=script&lang=js&"
export * from "./index-wuye.vue?vue&type=script&lang=js&"
import style0 from "./index-wuye.vue?vue&type=style&index=0&id=5794679e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794679e",
  null
  
)

export default component.exports